/** The choices only the person at this machine can make, and the machine's own local state. */

import { Banner, DataList, EmptyState, Panel, Skeleton, Stack } from "@/components/ui";

import { AgentProblem } from "./AgentProblem";
import { NONE, duration, orNone, yesNo } from "./format";
import { useAgentStatus } from "./queries";

export function AgentLocalSettings() {
  const status = useAgentStatus();

  if (status.isPending) {
    return <Skeleton height="14rem" />;
  }
  if (status.isError) {
    return <AgentProblem error={status.error} onRetry={() => void status.refetch()} />;
  }

  const data = status.data;

  return (
    <Stack gap={5}>
      {data.paired ? null : <Banner tone="warning" title="Not paired" />}
      {data.gaze_mode === "replay" ? <Banner tone="warning" title="Gaze substituted" /> : null}

      <Panel title="This machine">
        <DataList
          items={[
            {
              id: "machine",
              title: "Process",
              fields: [
                { label: "Environment", value: data.environment },
                { label: "Status", value: data.status },
                { label: "Paired", value: yesNo(data.paired) },
                { label: "Uptime", value: duration(data.uptime_seconds) },
              ],
            },
          ]}
        />
      </Panel>

      <Panel title="Screen canvas">
        <DataList
          items={[
            {
              id: "screen",
              title: "Desktop",
              fields: [
                { label: "Open", value: yesNo(data.overlay_open) },
                { label: "Click through", value: yesNo(data.overlay_click_through) },
                { label: "Monitor", value: data.overlay_monitor },
                {
                  label: "Rectangle",
                  value: data.overlay_rect === null ? NONE : data.overlay_rect.join(", "),
                  mono: true,
                },
                {
                  label: "Blocking",
                  value:
                    data.overlay_blocking.length === 0 ? NONE : data.overlay_blocking.join(", "),
                },
              ],
            },
          ]}
        />
      </Panel>

      <Panel title="Tracker">
        <DataList
          items={[
            {
              id: "tracker",
              title: orNone(data.tracker),
              fields: [{ label: "Gaze mode", value: orNone(data.gaze_mode) }],
            },
          ]}
        />
      </Panel>

      <Panel title="Output slots">
        <EmptyState bare headline="None" />
      </Panel>
    </Stack>
  );
}
